import { render, staticRenderFns } from "./pointRuleUserConfig.vue?vue&type=template&id=13b250cf&"
import script from "./pointRuleUserConfig.vue?vue&type=script&lang=js&"
export * from "./pointRuleUserConfig.vue?vue&type=script&lang=js&"
import style0 from "./pointRuleUserConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b250cf')) {
      api.createRecord('13b250cf', component.options)
    } else {
      api.reload('13b250cf', component.options)
    }
    module.hot.accept("./pointRuleUserConfig.vue?vue&type=template&id=13b250cf&", function () {
      api.rerender('13b250cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/pointActivity/pointRuleUserConfig.vue"
export default component.exports